<template>
  <div class="wang-editor-wrap" :style="{ border: '1px solid #ccc', borderRadius: '4px' }">
    <Toolbar
      style="border-bottom: 1px solid #ccc"
      :editor="editorRef"
      :default-config="toolbarConfig"
      mode="default"
    />
    <Editor
      v-model="innerValue"
      style="height: 300px; overflow-y: auto"
      :default-config="editorConfig"
      mode="default"
      :placeholder="placeholder"
      @onCreated="handleCreated"
      @onChange="handleEditorChange"
    />
  </div>
</template>

<script>
import '@wangeditor/editor/dist/css/style.css'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import { uploadFileToOSS } from '@/utils/oss-upload'

function normalizeImageUrl(url) {
  if (!url) return ''
  if (url.startsWith('http://') || url.startsWith('https://')) return url
  const origin = typeof window !== 'undefined' && window.location ? window.location.origin : ''
  return origin + (url.startsWith('/') ? url : '/' + url)
}

export default {
  name: 'WangEditor',
  components: { Editor, Toolbar },
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '请输入内容...'
    },
    maxImageSize: {
      type: Number,
      default: 5 * 1024 * 1024
    }
  },
  data() {
    const vm = this
    return {
      editorRef: null,
      toolbarConfig: { excludeKeys: [] },
      editorConfig: {
        placeholder: this.placeholder,
        MENU_CONF: {
          lineHeight: { lineHeightList: ['1', '1.15', '1.5', '1.75', '2', '2.5', '3'] },
          uploadImage: {
            async customUpload(file, insertFn) {
              try {
                if (file.size > vm.maxImageSize) {
                  vm.$message?.error?.('图片大小不能超过 5MB')
                  return
                }
                const result = await uploadFileToOSS(file, 'rich_text')
                const url = result?.fileUrl ? normalizeImageUrl(result.fileUrl) : null
                if (url) {
                  insertFn(url, file.name, url)
                  vm.$message?.success?.('图片上传成功')
                } else {
                  vm.$message?.error?.('图片上传失败')
                }
              } catch (e) {
                console.error('图片上传失败:', e)
                vm.$message?.error?.(e?.message || '图片上传失败')
              }
            }
          }
        }
      }
    }
  },
  computed: {
    innerValue: {
      get() {
        return this.value || ''
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  beforeDestroy() {
    if (this.editorRef) {
      this.editorRef.destroy()
      this.editorRef = null
    }
  },
  methods: {
    handleCreated(editor) {
      this.editorRef = editor
      this.$emit('ready', editor)
    },
    handleEditorChange(editor) {
      const html = editor.getHtml()
      this.$emit('change', { html, text: editor.getText(), editor })
    },
    getHtml() {
      return this.editorRef ? this.editorRef.getHtml() : this.innerValue
    },
    setHtml(html) {
      this.innerValue = html || ''
      if (this.editorRef) this.editorRef.setHtml(html || '')
    }
  }
}
</script>
